<template>
	<v-container fluid pa-0>
		<v-row align="center" no-gutters
			v-if="$store.projectsStore.state.selectedProject == 1">
				<div class="info-container d-flex flex-column text-center align-center py-1" style="width: 100%">
					<v-progress-circular
						:size="20"
						:width="2"
						color="#2D4B95"
						indeterminate
					></v-progress-circular>
					<p class="mb-0 body-2 ml-2">Cargando información del proyecto</p>
				</div>
		</v-row>
		<v-row align="center" no-gutters
			v-else-if="!$store.projectsStore.state.selectedProject">
				<div class="info-container d-flex flex-column text-center align-center py-1" style="width: 100%">
					<p class="mb-0 body-2 ml-2">No hay proyectos seleccionados</p>
					<p class="mb-0 body-2 ml-2 caption">Crea tu primer proyecto</p>
					<v-btn
						class="mx-2 my-1"
						rounded
						color="#34BFA3"
						dark
						x-small
						@click="() => $store.projectsStore.commit('setNewProjectModal', true)"
					>
						<v-icon dark small>mdi-plus-circle-outline</v-icon>
						<p class="mb-0 ml-2">Nuevo Proyecto</p>
					</v-btn>
				</div>
		</v-row>
		<v-row align="center" no-gutters v-else-if="$store.projectsStore.state.selectedProject" class="info-row">
			<div class="info-chip" :title="$store.projectsStore.state.selectedProject.name">
				<v-icon x-small class="info-icon-plain">mdi-office-building-outline</v-icon>
				<div class="info-text">
					<span class="info-label">Proyecto</span>
					<span class="info-value">{{$store.projectsStore.state.selectedProject.name}}</span>
				</div>
			</div>
			<div class="info-chip" :title="$store.projectsStore.state.selectedProject.description">
				<v-icon x-small class="info-icon-plain">mdi-clipboard-minus-outline</v-icon>
				<div class="info-text">
					<span class="info-label">Descripción</span>
					<span class="info-value">{{$store.projectsStore.state.selectedProject.description}}</span>
				</div>
			</div>
			<div class="info-chip" :title="$store.projectsStore.state.selectedProject.company.name">
				<v-icon x-small class="info-icon-plain">mdi-domain</v-icon>
				<div class="info-text">
					<span class="info-label">Empresa</span>
					<span class="info-value">{{$store.projectsStore.state.selectedProject.company.name}}</span>
				</div>
			</div>
			<div class="info-chip" :title="$store.projectsStore.state.selectedProject.type.name">
				<v-icon x-small class="info-icon-plain">mdi-developer-board</v-icon>
				<div class="info-text">
					<span class="info-label">Tipo</span>
					<span class="info-value">{{$store.projectsStore.state.selectedProject.type.name}}</span>
				</div>
			</div>
		</v-row>
		<v-row align="center" no-gutters v-else class="info-row">
			<div class="info-chip" v-for="i in 4" :key="i">
				<v-skeleton-loader type="text" width="80"></v-skeleton-loader>
			</div>
		</v-row>
	</v-container>
</template>

<script>

export default {
	name: 'HeaderProjectInfo',
	components: {
	},
	data: () => ({
		//
	}),
	mounted(){
	}
};
</script>

<style scoped>
	.info-row {
		flex-wrap: wrap;
		gap: 4px;
		padding: 2px 0;
	}
	.info-chip {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		background: #F4F6FC;
		border-radius: 10px;
		padding: 4px 10px;
		max-width: 200px;
		min-width: 0;
		cursor: default;
	}
	.info-icon-plain {
		color: #5E85EF;
		flex-shrink: 0;
		opacity: 0.85;
	}
	.info-text {
		display: flex;
		flex-direction: column;
		line-height: 1.2;
	}
	.info-label {
		font-size: 10px;
		color: #9e9e9e;
		font-weight: 400;
		text-transform: uppercase;
		letter-spacing: 0.3px;
	}
	.info-text {
		min-width: 0;
	}
	.info-value {
		font-size: 12px;
		color: #2D4B95;
		font-weight: 600;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
